import { CIcon } from '~/icons/types'

export const ciAntiques: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.587 16.277c1.274-2.308-.359-4.2-1.953-6.03-1.822-2.095-3.887-4.469-2.934-8.119a.5.5 0 0 0-.865-.45l-7.866 9.323a.5.5 0 0 0 .568.786c3.3-1.328 8.716.438 10.192 2.674a1.366 1.366 0 0 1-.052 1.8h-5.355v-.741h3.856a.5.5 0 1 0 0-1h-3.856v-.371a.5.5 0 0 0-1 0v.37H5.465a.5.5 0 0 0 0 1h3.857v.743H5.594a1.5 1.5 0 0 0-1.5 1.5v2.355a1.5 1.5 0 0 0 1.5 1.5h1.114V22a.5.5 0 1 0 1 0v-.384h8.585V22a.5.5 0 0 0 1 0v-.384h1.113a1.5 1.5 0 0 0 1.5-1.5v-2.357a1.5 1.5 0 0 0-1.319-1.482Zm-11.835-5.84 5.712-6.766c-.115 3.172 1.816 5.393 3.416 7.23 1.889 2.171 2.911 3.518 1.54 5.355h-.552a2.412 2.412 0 0 0-.3-2.348c-1.481-2.236-6.153-4.023-9.816-3.47Zm12.154 9.679a.5.5 0 0 1-.5.5H5.594a.5.5 0 0 1-.5-.5v-2.357a.5.5 0 0 1 .5-.5h12.812a.5.5 0 0 1 .5.5v2.357Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'antiques',
  type: 'thin'
}
